export default "__VITE_ASSET__CiH4VP45__"